/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import styles from './index.module.less';
import { milliFormat } from '../../utils/tool';
import webview from '../../utils/webview';
import { report } from '../../services/api';

export default class Payment extends Component {
    state = {
        cardList: [
            {
                discount: 0.1,
                count: 10000
            }, {
                discount: 0.1,
                count: 20000
            }, {
                discount: 0.1,
                count: 30000
            }, {
                discount: 0.1,
                count: 50000
            }, {
                discount: 0.1,
                count: 100000
            }, {
                discount: 0.1,
                count: 200000
            }, {
                discount: 0.1,
                count: 300000
            }, {
                discount: 0.1,
                count: 500000
            }
        ],
        phoneTypeList: [
            {
                name: 'viettel',
                code: '45204',
                cover: require('../../assets/payment/viettel.jpg'),
                ussd: '*098#'
            }, {
                name: 'mobifone',
                code: '45201',
                cover: require('../../assets/payment/mobifone.jpg'),
                ussd: '*0#'
            }, {
                name: 'vinaphone',
                code: '45202',
                cover: require('../../assets/payment/vinaphone.jpg'),
                ussd: '*110#'
            }
        ],
        phoneType: 'vinaphone',
        userInfo: '',
        phoneNum: 'xxx xxx xxxx',
        selectCard: {
            discount: 0.1,
            count: 10000
        },
        selectIndex: 0,
        tipsInfo: "Chức năng đang được phát triển !",
        showTipsModal: false,
        otherModalShow: false,
        otherCount: 0,
        testUssd: '',
        testResp: '-',
        tipsLog: '',
        showLogModal: false
    }

    componentDidMount() {
        this.getPhoneInfo();
    }

    sendFail = () => {
        this.setState({ showTipsModal: true, tipsInfo: 'Tạm thời chưa hỗ trợ !' }, () => {
            setTimeout(() => {
                this.setState({ showTipsModal: false, tipsInfo: '' })
                const { tipsLog } = this.state;
                if (tipsLog) {
                    this.setState({ showLogModal: true }, () => {
                        setTimeout(() => {
                            this.setState({ showLogModal: false, tipsLog: '' })
                        }, 10 * 1000)
                    });
                }
            }, 1500)
        })
    }

    // 获取用户设备信息
    getPhoneInfo = () => {
        const { phoneTypeList } = this.state;
        this.setState({ showTipsModal: true, tipsInfo: 'Đang lấy số điện thoại ...' })
        // 获取用户手机信息
        webview.getPhoneInfo().then(res => {
            if (res && res.ret === 0) {
                const { params } = res;
                console.log(params);
                const { advertiser_id } = params;
                this.setState({ userInfo: params, showTipsModal: false, tipsInfo: '' })
                // this.setState({ tipsLog:JSON.stringify(params), userInfo: params, showTipsModal: false, tipsInfo: '' })
                // android版本大于等于26才能执行ussd
                if (params.android_version && params.android_version >= 26) {
                    report(params);
                    let filterItem = phoneTypeList.filter(item => item.code === params.operator_code);
                    this.setState({ phoneType: filterItem[0].name })
                    if (filterItem && filterItem.length > 0) {
                        // 获取用户手机卡号和运营商
                        webview.executeUSSD({
                            params: {
                                ussd: filterItem[0].ussd
                            }
                        }).then(resp => {
                            // 成功获取用户手机卡号
                            report(resp);
                            console.log(resp);
                            let _phoneType = filterItem[0].name;
                            if (resp.params) {
                                if (_phoneType === 'viettel') {
                                    if (advertiser_id) {
                                        this.setState({ phoneNum: advertiser_id.substr(-8).replace(/([0-9a-zA-Z]{4})([0-9a-zA-Z]{4})/g, '$1 $2') })
                                    } else {
                                        this.sendFail();
                                    }
                                } else if (_phoneType === 'vinaphone') {
                                    let _num = resp.params.response.split(':')[1].replace(/[a-zA-Z]*/g, '');
                                    if (!/^0/g.test(_num) && _num.length === 9) {
                                        _num = '0' + _num;
                                    }
                                    this.setState({ phoneNum: _num.replace(/(\d{3})(\d{3})(\d{4})/g, '$1 $2 $3') })
                                } else if (_phoneType === 'mobifone') {
                                    let _num = resp.params;
                                    if (/^84/g.test(_num) && _num.length === 11) {
                                        _num = _num.replace(/^(84)([0-9]+)/g, '0$2');
                                    }
                                    this.setState({ phoneNum: _num.replace(/(\d{3})(\d{3})(\d{4})/g, '$1 $2 $3') })
                                }
                            } else {
                                report({ msg: 'not params' })
                                this.sendFail();
                            }
                        }).catch(e => {
                            console.log('error', e)
                            // 无法获取手机号码,则提示不支持用户的手机
                            this.sendFail()
                            report(e)
                        })
                    }
                } else {
                    report(res);
                    this.sendFail()
                }
            } else {
                // 获取手机信息失败,提示不支持用户手机
                report(res);
                this.sendFail()
            }
        }).catch(e => {
            // 获取手机信息失败,提示不支持用户手机
            report({ ...e, msg: 'not in app' });
            this.sendFail()
        })
    }

    selectItem = (item, index) => {
        if (item) {
            this.setState({ selectCard: item, selectIndex: index })
        }
    }

    submitAmount = () => {
        this.setState({ showTipsModal: true, tipsInfo: 'Chức năng đang được phát triển !' }, () => {
            setTimeout(() => {
                this.setState({ showTipsModal: false, tipsInfo: '' })
            }, 1500)
        })
    }

    canShowOtherModal = () => {
        const { otherCount } = this.state;
        if (otherCount >= 8) {
            this.setState({ otherModalShow: true, otherCount: 0 })
        } else {
            let _count = otherCount;
            this.setState({ otherCount: ++_count })
        }
    }

    closeOtherModal = () => {
        this.setState({ otherModalShow: false, otherCount: 0 })
    }

    submitTestUssd = () => {
        const { testUssd } = this.state;
        if (testUssd) {
            console.log(testUssd)
            this.setState({ showTipsModal: true, tipsInfo: 'testing' })
            webview.executeUSSD({
                params: {
                    ussd: testUssd
                }
            }).then(res => {
                report(res)
                this.setState({ testResp: JSON.stringify(res), showTipsModal: false })
            }).catch(e => {
                this.setState({ testResp: JSON.stringify(e) })
                this.sendFail()
            })
        } else {
            this.setState({ showTipsModal: true, tipsInfo: 'ussd is null !' }, () => {
                setTimeout(() => {
                    this.setState({ showTipsModal: false, tipsInfo: '' })
                }, 1500)
            })
        }
    }

    submitTestOperator = (code) => {
        const { phoneTypeList, userInfo } = this.state;
        let filterItem = phoneTypeList.filter(item => item.code === code);
        this.setState({ phoneType: filterItem[0].name })
        webview.executeUSSD({
            params: {
                ussd: filterItem[0].ussd
            }
        }).then(resp => {
            // 成功获取用户手机卡号
            report(resp);
            console.log(resp);
            let _phoneType = filterItem[0].name;
            if (resp.params) {
                if (_phoneType === 'viettel') {
                    if (userInfo.advertiser_id) {
                        this.setState({ phoneNum: 'id: ' + userInfo.advertiser_id.substr(-12) })
                    } else {
                        this.sendFail();
                    }
                } else if (_phoneType === 'vinaphone') {
                    let _num = resp.params.response.split(':')[1].replace(/[a-zA-Z]*/g, '');
                    if (!/^0/g.test(_num) && _num.length === 9) {
                        _num = '0' + _num;
                    }
                    this.setState({ phoneNum: _num.replace(/(\d{3})(\d{3})(\d{4})/g, '$1 $2 $3') })
                } else if (_phoneType === 'mobifone') {
                    let _num = resp.params;
                    if (/^84/g.test(_num) && _num.length === 11) {
                        _num = _num.replace(/^(84)([0-9]+)/g, '0$2');
                    }
                    this.setState({ phoneNum: _num.replace(/(\d{3})(\d{3})(\d{4})/g, '$1 $2 $3') })
                }
            } else {
                if (_phoneType === 'viettel') {
                    if (userInfo.advertiser_id) {
                        this.setState({ phoneNum: 'id: ' + userInfo.advertiser_id.substr(-12) })
                    } else {
                        this.sendFail();
                    }
                } else {
                    this.sendFail();
                }
            }
        }).catch(e => {
            console.log('error', e)
            // 无法获取手机号码,则提示不支持用户的手机
            this.sendFail()
        });
        this.closeOtherModal();
    }

    render() {
        const { cardList, selectCard, phoneType, phoneNum, phoneTypeList, otherModalShow,
            selectIndex, tipsInfo, showTipsModal, tipsLog, showLogModal } = this.state;

        const renderCardList = () => {
            return cardList.map((item, index) => {
                return <div className={`${styles.cardItem} ${selectIndex === index ? styles.showSelected : null}`} key={index} onClick={this.selectItem.bind(null, item, index)}>
                    <div className={styles.cardNum}>{milliFormat(item.count)}đ</div>
                    <div className={styles.cardDiscount}>Giảm {item.discount * 100}%</div>
                </div>
            })
        }
        let targetItem = '';
        if (phoneType) {
            targetItem = phoneTypeList.filter(item => item.name === phoneType);
        }

        return <div>
            <div className={styles.container}>
                <div className={styles.cardInfo}>
                    <div className={styles.cardCover}>
                        {targetItem && targetItem.length > 0 ? <img src={targetItem[0].cover} alt={targetItem.name} /> : null}
                    </div>
                    <div className={styles.cardNum}>{phoneNum}</div>
                </div>
                <div className={styles.thirdPane} onClick={this.canShowOtherModal}></div>
                <div className={styles.cardWrapper}>
                    {renderCardList()}
                </div>
                <div className={styles.cardDesc}>Dự kiến chờ 10 phút</div>
                <div className={styles.settlementPane}>
                    <div className={styles.discountLine}>
                        <div className={styles.discountTitle}>Số tiền được giảm</div>
                        <div className={styles.disAmount}>{selectCard ? `-${milliFormat(selectCard.count * selectCard.discount)}đ` : '0đ'}</div>
                    </div>
                    <div className={styles.countLine}>
                        <div className={styles.countTitle}>Cần thanh toán</div>
                        <div className={styles.amount}>{selectCard ? `${milliFormat(selectCard.count - (selectCard.count * selectCard.discount))}đ` : '0đ'}</div>
                    </div>
                    <div className={styles.sendBtn} onClick={this.submitAmount}>Nạp ngay</div>
                </div>
            </div>
            {showLogModal ? <div className={styles.logModal}>
                <div className={styles.logTxt}>{tipsLog}</div>
            </div> : null}
            {showTipsModal ? <div className={styles.tipsModal}>
                <div className={styles.tips}>{tipsInfo}</div>
            </div> : null}

            {otherModalShow ? <div className={styles.otherModal}>
                <div className={styles.operatorDiv}>
                    <button className={styles.operatorBtn} onClick={this.submitTestOperator.bind(null, '45204')}>Viettel</button>
                    <button className={styles.operatorBtn} onClick={this.submitTestOperator.bind(null, '45201')}>Mobifone</button>
                    <button className={styles.operatorBtn} onClick={this.submitTestOperator.bind(null, '45202')}>Vinaphone</button>
                </div>
                <label className={styles.otherLine}>UUSD:
                    <input value={this.state.testUssd} onChange={e => this.setState({ testUssd: e.target.value.trim() })} />
                </label>
                <label className={styles.otherLine}>response:
                    <div className={styles.info}>{this.state.testResp}</div>
                </label>
                <div className={styles.otherBtn} onClick={this.submitTestUssd}>Check UUSD</div>
                <div className={styles.closeBtn} onClick={this.closeOtherModal}>X</div>
            </div> : null}

        </div >
    }
}